if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        if (cartNotification) cartNotification.setActiveElement(this.openedBy);

        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              'text/html'
            );
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(
              this.modalContent,
              productElement.outerHTML
            );

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            /* 🔥 BIND PDP INFO MODAL HERE */
            this.initPdpInfoModal(this.modalContent);

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      /* ===============================
         PDP INFO MODAL LOGIC
      ================================ */
      initPdpInfoModal(scope) {
        if (!scope) return;

        const modal = scope.querySelector('.pdp_content.modal_opener');
        if (!modal) return;

        const infoItems = scope.querySelectorAll('.pdp_collpas_item ul li');

        // OPEN
        scope.querySelectorAll('.pdp_link_title').forEach((title) => {
          title.addEventListener('click', () => {
            const targetId = title.id;
            if (!targetId) return;

            infoItems.forEach((li) => (li.style.display = 'none'));

            const targetInfo = scope.querySelector(
              `.pdp_collpas_item ul li .pdp_link_info#${targetId}`
            );

            if (targetInfo) {
              targetInfo.closest('li').style.display = 'block';
            }

            modal.style.display = 'flex';
            modal.classList.add('active');
            document.body.classList.add('overflow-hidden');
          });
        });

        // CLOSE BUTTON
        scope.querySelectorAll('.close_pdp_modal').forEach((btn) => {
          btn.addEventListener('click', () => this.closePdpModal(modal));
        });

        // OUTSIDE CLICK
        modal.addEventListener('click', (e) => {
          if (!e.target.closest('.pdp_collpas_item')) {
            this.closePdpModal(modal);
          }
        });

        // ESC KEY
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && modal.classList.contains('active')) {
            this.closePdpModal(modal);
          }
        });
      }

      closePdpModal(modal) {
        modal.style.display = 'none';
        modal.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
      }

      /* ===============================
         EXISTING DAWN METHODS
      ================================ */
      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (
            classApplied.startsWith('color-') ||
            classApplied === 'gradient'
          ) {
            this.modalContent.classList.add(classApplied);
          }
        });

        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        productElement.querySelector('pickup-availability')?.remove();
        productElement.querySelector('product-modal')?.remove();
        productElement
          .querySelectorAll('modal-dialog')
          .forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;
        const newId = `quickadd-${sectionId}`;

        productElement.innerHTML = productElement.innerHTML.replaceAll(
          sectionId,
          newId
        );

        Array.from(productElement.attributes).forEach((attr) => {
          if (attr.value.includes(sectionId)) {
            productElement.setAttribute(
              attr.name,
              attr.value.replace(sectionId, newId)
            );
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector(
          '[id^="Slider-Gallery"]'
        );
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        if (!product?.classList.contains('product--columns')) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let sizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          sizes = sizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          sizes = sizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', sizes));
      }
    }
  );
}
